var linktype={

    GENERLWEB:"1",
    LOGIN:"2",
    PLP:"3",
    PDP:"1",
    INDEX:"5",
    DS_SHOP_LIST:"6",
    DS_SHOP_DTL:"7",
    DS_SHOP_NAV:"8",
    ACAFE_ACT_LIST:"109",
    ACAFE_UPLOAD:"110",
    ACAFE_YOUXUAN:"111",
    DS_MS_LIST:"15",
    DS_MS_DTL:"16",
    DS_MS_NAV:"17",
    SEARCH:"18",
    GOBACK:"999"


};

/*
 * make PDP link
 */
linktype.makePDPLink=(_8d)=>{

    return window.location.origin +"/content/dam/sonystyle-wechat/index.html#/Product?eightD=" +_8d;
}

linktype.makeAction=(tp)=>{

    var act="";
    if(tp==linktype.PDP){
        act="goProduct";
    }

    if(tp==linktype.LOGIN){
        act="loadLoginPage";
    }

    if(tp==linktype.GOBACK){

        act="goback";
    }

    return act;
    

}

linktype.makeTile=(act)=>{
    var title="索尼中国";

    if(act==linktype.PDP){
        title="产品详情";
    }

    return title;


}

//jump to web


export default linktype;


// WEBPACK FOOTER //
// ./src/commons/utils/linktype.js